(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/number-selector/assets/javascripts/number-selector-text.js') >= 0) return;  svs.modules.push('/components/lb-ui/number-selector/assets/javascripts/number-selector-text.js');
"use strict";

const NumberSelectorText = _ref => {
  let classname = _ref.classname,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    value = _ref.value;
  const classNames = ['number-selector-text'];
  if (classname) {
    classNames.push(classname);
  }
  prefix = prefix || '';
  suffix = suffix || '';
  const inputValue = "".concat(prefix).concat(value).concat(suffix);
  return React.createElement("h2", {
    className: classNames.join(' ')
  }, inputValue);
};
setGlobal('svs.components.lbUi.numberSelector.NumberSelectorText', NumberSelectorText);

 })(window);